import React from 'react';
import {GridLinkedContent} from '../components/GridContent'
import '../style.css';

export default function Writing() {
  return (
  	<div className="content load-first">
        <h2>Writing & Reporting</h2>

        <p>Below is a selection of my news, feature and magazine work. You can access more of my articles <a href="https://www.uscannenbergmedia.com/author/nina-moothedath/" class="show">here.</a></p>

        <div className="load-second grid">
        <GridLinkedContent link="https://finance.yahoo.com/news/nvidia-how-the-chipmaker-evolved-from-a-gaming-startup-to-an-ai-giant-140140110.html" src="https://public.flourish.studio/story/3176162/thumbnail" caption="NVIDIA's journey from chipmaker to AI giant" alt="Chart of NVIDIA stock"/>
        <GridLinkedContent link="https://ascjcapstone.com/spring-2025/mootheda/" src="https://ascjcapstone.com/spring-2025/mootheda/img/header.png" caption="Archiving the Ordinary: The people saving the history of everyday lives" alt="Cover art for article" />
        <GridLinkedContent link="https://www.uscannenbergmedia.com/2024/04/09/everywhere-is-queer-app-launches-to-help-lgbtq-users-support-their-local-community/" src="https://www.uscannenbergmedia.com/resizer/VJZPdSVyLqKpWkCS3w8nIg44Ilc=/800x0/filters:format(png):quality(70)/cloudfront-us-east-1.images.arcpublishing.com/uscannenberg/SZGPBS63BJAO3GD6JSZCWQCIME.png" caption="App launches to help LGBTQ+ users support their local community" alt="Image of founder Charlie Sprinkman in front of Everywhere is Queer Map"/>

        </div>

        <div className="magazine load-third">
          <iframe title="flipbook" allowfullscreen="allowfullscreen" scrolling="no" class="fp-iframe" src="https://heyzine.com/flip-book/59922be85d.html"></iframe>
        </div>
        
      </div>
    );
}